<template>
  <div class="display-page">
    <GlobalHeader
      :instructions="instructions"
      :iconType="instructions.headerIcon ? instructions.headerIcon : brandTheme.globalHeader.headerIcon"
    />

    <div class="page-content-container center-text">
      <div v-if="instructions.haloDeviceResource" class="display-page__halo-container">
        <BaseImage
          :src="instructions.haloDeviceResource"
          id="intro-primary-image"
        />
      </div>
      <div v-else-if="instructions.resourceAdditionalClasses" :class="['display-page__rescource-container', instructions.resourceAdditionalClasses]">
        <BaseImage
          :src="instructions.resource"
          id="intro-primary-image"
        />
      </div>
      <div v-else>
        <BaseResource
          :instructions="instructions"
          id="intro-primary-image"
        />
      </div>
      <div class="page-content">
        <div>
          <h2
            name="intro-primary-text"
            id="intro-primary-text"
            class="display-page__title-text"
          >{{ instructions.primaryTx ? $t(instructions.primaryTx) : instructions.primaryText }}</h2>
          <template
            v-if="instructions.includeInstallationSteps || instructions.includePairingProcess"
          >
            <p
              v-if="instructions.includeInstallationSteps && instructions.includePairingProcess"
              name="intro-secondary-text"
              id="intro-secondary-text"
              class="display-page__body-text"
            >{{ instructions.secondaryTx ? $t(instructions.secondaryTx) : instructions.secondaryText }} {{ $t('intro.installationStepsAndPairing') }}</p>
            <p
              v-else-if="instructions.includeInstallationSteps"
              name="intro-secondary-text"
              id="intro-secondary-text"
              class="display-page__body-text"
            >{{ instructions.secondaryTx ? $t(instructions.secondaryTx) : instructions.secondaryText }} {{ $t('intro.installationSteps') }}</p>
            <p
              v-else
              name="intro-secondary-text"
              id="intro-secondary-text"
              class="display-page__body-text"
            >{{ instructions.secondaryTx ? $t(instructions.secondaryTx) : instructions.secondaryText }} {{ $t('intro.pairingProcess') }}</p>
          </template>
          <p
            v-else
            name="intro-secondary-text"
            id="intro-secondary-text"
            class="display-page__body-text"
          >{{ instructions.secondaryTx ? $t(instructions.secondaryTx) : instructions.secondaryText }}</p>
          <p
              v-if="instructions.additionalTx || instructions.additionalText"
              name="intro-secondary-text"
              id="intro-secondary-text"
              class="display-page__body-text"
            >{{ instructions.additionalTx ? $t(instructions.additionalTx) : additionalText}} </p>

        </div>
      </div>

      <ButtonFooter
        :instructions="instructions"
        isIntro
      />
    </div>
  </div>
</template>
<script>
import BaseImage from '../components/BaseImage.vue';
import BaseResource from '../components/BaseResource.vue';
import GlobalHeader from '../components/GlobalHeader';
import ButtonFooter from '../components/ButtonFooter';
import { mapState } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'InstallationIntro',
  components: {
    BaseResource,
    BaseImage,
    ButtonFooter,
    GlobalHeader,
  },
  computed: {
    ...mapState(['brands']),
    brandTheme() {
      const { brand } = this.$route.params;
      return get(this, ['brands', brand, 'theme'], {});
    },
    instructions() {
      const { brand, device } = this.$route.params;
      return get(this, ['brands', brand, 'devices', device, 'installationInstructions', 'intro'], {});
    },
  },
  beforeCreate() {
    const { brand } = this.$route.params;
    document.body.classList.add(brand);
  },
};
</script>
